/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DetailsSolicitations_solicitationStateTypes$ref: FragmentReference;
declare export opaque type DetailsSolicitations_solicitationStateTypes$fragmentType: DetailsSolicitations_solicitationStateTypes$ref;
export type DetailsSolicitations_solicitationStateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: DetailsSolicitations_solicitationStateTypes$ref,
|};
export type DetailsSolicitations_solicitationStateTypes$data = DetailsSolicitations_solicitationStateTypes;
export type DetailsSolicitations_solicitationStateTypes$key = {
  +$data?: DetailsSolicitations_solicitationStateTypes$data,
  +$fragmentRefs: DetailsSolicitations_solicitationStateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DetailsSolicitations_solicitationStateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c0c81f95e3bac509b25bd1aa0e32d786';
module.exports = node;
